import { useResponsive } from '../../../../hooks/useResponsive';
import { cn } from '../../../../lib/utils';
import { EdgeFunctionsPanel } from './EdgeFunctionsPanel';
import { SecretsPanel } from './SecretsPanel';

interface EdgeFunctionsSecretsTabProps {
  projectId: string;
}

export function EdgeFunctionsSecretsTab({ projectId }: EdgeFunctionsSecretsTabProps) {
  const { isMobile } = useResponsive();

  return (
    <div className={cn(
      "h-full",
      isMobile ? "flex flex-col gap-6 overflow-y-auto" : "flex gap-6"
    )}>
      {/* Left: Edge Functions */}
      <div className={cn(
        isMobile ? "flex-shrink-0" : "w-[55%] h-full flex-shrink-0 overflow-y-auto pr-2"
      )}>
        <EdgeFunctionsPanel projectId={projectId} />
      </div>

      {/* Right: Secrets */}
      <div className={cn(
        "flex-1 min-w-0 flex flex-col rounded-lg border border-border bg-card",
        isMobile ? "min-h-[400px]" : "h-full overflow-y-auto"
      )}>
        <div className={cn(isMobile ? "p-4" : "p-5")}>
          <SecretsPanel projectId={projectId} />
        </div>
      </div>
    </div>
  );
}
